import {
  SET_PASSWORD,
  SET_PASSWORD_SUCCESS,
  SET_PASSWORD_FAILURE,
} from './action';

const initialState = {
  loading: false,
  data: [],
  error: '',
};

const setPasswordReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_PASSWORD:
      return { ...state, loading: true };
    case SET_PASSWORD_SUCCESS:
      return { ...state, loading: false, data: action.payload, error: '' };
    case SET_PASSWORD_FAILURE:
      return { ...state, loading: false, data: [], error: action.payload };
    default:
      return state;
  }
};

export default setPasswordReducer;
